var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"envia-hero"},[_c('img',{staticClass:"envia-hero__banner",attrs:{"alt":"Tendencys","src":_vm.getHeroImage()},on:{"error":_vm.getHeroImageError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }